import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BackendMenuItem } from '../shared/models/menu-item.model';

@Injectable({ providedIn: 'root' })
export class ModulosService {
  private http = inject(HttpClient);

  getMenu(): Observable<BackendMenuItem[]> {
    return this.http.get<BackendMenuItem[]>('/api/modulos/menu');
  }
}
